import ReactDOM from "react-dom/client";
import "./style.css";
import {App} from "./App.js";

const root = ReactDOM.createRoot(document.getElementById("container"))

root.render(<App></App>);